(() => {
  if (!window.atob) {
    return;
  }

  const userAgent = window.navigator.userAgent.toLowerCase();

  if (
    userAgent.indexOf('webos') === -1
    && userAgent.indexOf('tizen') === -1
    && userAgent.indexOf('bravia') === -1
    && userAgent.indexOf('smart-tv') === -1
    && userAgent.indexOf('smarttv') === -1
    && userAgent.indexOf('smart tv') === -1
    && userAgent.indexOf('playstation') === -1
    && userAgent.indexOf('silk') === -1
    && !window.swinger.storage.get('swinger.debug-console')
  ) {
    return;
  }

  if (window.swinger.user.getId() !== 482281 && !window.swinger.config.isClickDummy) {
    return;
  }

  window.swinger.resourceLoader.script(atob('aHR0cHM6Ly9kZWJ1Zy5mZnJ0ei5jb20vdGFyZ2V0Lmpz'), () => {
    console.log(atob('WW91IGNhbiBzdGFydCBkZWJ1Z2dpbmcgb24gdW5kZXIgaHR0cHM6Ly9kZWJ1Zy5mZnJ0ei5jb20='));
  });
})();
